import { useState } from 'react';
import './App.css';
import { Footer } from './components/Footer';

const LOCATION = {
  HOME: 'home',
  PROJECTS: 'projects',
  ABOUT: 'about',
  CONTACT: 'contact'
}

function Projects() {
  return (
    <div className='App-contact'>
      <div className='content'>
        <p className='content-title'>
          S E L E C T E D &nbsp; P R O J E C T S
        </p>
        <br/>
        <p>
         This page is currently under construction 
        </p>
      </div>
      <div className='App-footer'>
        <p>
        <span className="title">A R T H U R &nbsp; D E S I G N &nbsp; C O . &nbsp; L L C</span> 
        <span className="number"> 8 0 4 &nbsp; .&nbsp; 6 5 8 &nbsp; .&nbsp; 7 4 5 8</span>
      </p>
      </div>
    </div>
  )
}

function About() {
  return (
    <div className='App-contact'>
      <div className='content'>
        <p className='content-title'>
          A B O U T
        </p>
        <br/>
        <p>
         This page is currently under construction 
        </p>
      </div>
      <div className='App-footer'>
        <p>
        <span className="title">A R T H U R &nbsp; D E S I G N &nbsp; C O . &nbsp; L L C</span> 
        <span className="number"> 8 0 4 &nbsp; .&nbsp; 6 5 8 &nbsp; .&nbsp; 7 4 5 8</span>
      </p>
      </div>
    </div>
  )
}

function Contact() {
  return (
    <div className='App-contact'>
      <div className='content'>
        <p className='content-title'>
          C O N T A C T
        </p>
        <br/>
        <p>
          E M A I L :
          <br />
          haley@arthurdesign.co
        </p>
        <p>
          P H O N E :
          <br />
          804.658.7458
        </p>
        <p>
          S O C I A L &nbsp; M E D I A:
          <br />
          @arthurdesign.co
        </p>
      </div>
      <div className='App-footer'>
        <p>
        <span className="title">A R T H U R &nbsp; D E S I G N &nbsp; C O . &nbsp; L L C</span> 
        <span className="number"> 8 0 4 &nbsp; .&nbsp; 6 5 8 &nbsp; .&nbsp; 7 4 5 8</span>
      </p>
      </div>
      
    </div>
  )
}

function Home() {
  return (
    <div className='App-home'>
      <p>
        <span className="title">A R T H U R &nbsp; D E S I G N &nbsp; C O. &nbsp; L L C</span> 
        <span className="number"> 8 0 4 &nbsp; .&nbsp; 6 5 8 &nbsp;.&nbsp; 7 4 5 8</span>
      </p>
    </div>
  )
}

function App() {
  const [location, setLocation] = useState(LOCATION.HOME)
  return (
    <div className='App' >
      <header className="App-header">
        <img className='App-logo' onClick={() => setLocation(LOCATION.HOME)} src={require('./Logo.jpg')} alt="logo" />
        <div className='menu'>
          {/* <img src={require('./Hamburger_icon.svg.png')} alt="menu" /> */}
          <span style={{color: location === LOCATION.PROJECTS ? 'white' : null}} onClick={() => setLocation(LOCATION.PROJECTS)}>S E L E C T E D &nbsp; P R O J E C T S</span>
          <span style={{color: location === LOCATION.ABOUT ? 'white' : null}} onClick={() => setLocation(LOCATION.ABOUT)}>A B O U T</span>
          <span style={{color: location === LOCATION.CONTACT ? 'white' : null}} onClick={() => setLocation(LOCATION.CONTACT)}>C O N T A C T</span>
        </div>
      </header>
      {(() => {
          switch (location) {
            case LOCATION.PROJECTS:
              return <Projects />;
            case LOCATION.ABOUT:
              return <About />;
            case LOCATION.CONTACT:
              return <Contact />;
            default:
              return <Home />;
          }
        })()}
    </div>
  );
}

export default App;
